import React from "react";
import "../../InsHeader/InsHeader.scss";
import images from "../../../ressources/images";
import './LogoCustomTheme.scss';
import { useSelector } from "react-redux";

const LogoCustomTheme = (props) => {
  const config = useSelector((state) => state.config);
  const { differentLogo = false } = props;
  
  const theme = config?.theme ?? "Default";
  const themeLogoSrc = differentLogo
    ? `different_logo_${theme}`
    : `logo_${theme}`;
  const defaultLogoSrc = `logo_${theme}`;
  const logoSrc = images?.[themeLogoSrc] ?? images?.[defaultLogoSrc] ?? "";

  return (
      <div className={props.className}>
        <img src={logoSrc} alt="logo white" />
      </div>
  );
};

export default LogoCustomTheme;
